const formats = {
  time: "HH:mm",
  ymd: "yyyy-MM-dd",
  monthYear: "MMM yyyy",
  monthDayYear: "MMM dd, yyyy",
  dayOfWeekMonthDayYear: "EEE MMM dd, yyyy",
  dayOfWeekMonthDayYearTime: "EEE MMM dd, yyyy 'at' HH:mm",
  dateTimeOffsetSevenDigitFractionalTSQL: "yyyy-MM-dd HH:mm:ss.SSSSSSS xxx", // 2020-09-24 12:49:54.3243540 -04:00
};

export { formats };
